<template>
  <div class="doc-container -scrollable text">
      <iframe v-show="iframeShow" ref="iframe" id="iframe" frameborder=0 class="iframe" scrolling="auto" :src="iframeSrc" width="100%" height="100%" />
  </div>
</template>

<style lang="scss">
.doc-container {
  .iframe {
    width: 100%;
    min-height: calc(100vh - 23px);
  }
}
</style>

<script>
import { messages } from "@/lib/emitter"
import { docTest } from "../lib/doc"
import { Logger } from "../lib/logger"
const log = Logger("app:app-doc")

export default {
  name: "app-doc",
  components: {},
  data() {
    return {
      iframeShow: false,
      iframeSrc: "",
    }
  },
  created() {
    //console.log('app-doc created')
    //this.iframeSrc = 'https://m.baidu.com'
  },
  mounted() {
    //console.log('app-doc mounted')
    messages.on("loadDoc", (doc) => {
      this.iframeSrc = doc
      this.iframeShow = true
    })
    
    messages.on("unloadDoc", () => {
      this.iframeShow = false
      this.iframeSrc = ""
    })
    
    if(this.state.isPC) { messages.emit("loadDoc", '/welcome.html') }
  },
  beforeDestroy() {
    //console.log('app-doc beforeDestroy')
  },
  methods: {
    selectAll() {
      setTimeout(() => {
        let el = this.$refs.input
        el.select()
      }, 0)
    },
  },
}
</script>
